function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0)"
}, React.createElement("path", {
  d: "M31.0248 30.987H1.02637V0.92627H31.0248V30.987Z",
  fill: "#26BBED",
  stroke: "#26BBED",
  strokeWidth: 2
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.69006 20.471H6.95604V15.3149C6.95604 15.1173 6.97248 14.8866 7.00536 14.7054C7.20265 13.8653 7.64657 13.437 8.23845 13.437C9.09339 13.437 9.30713 14.3595 9.30713 15.3314V20.471H10.5731V15.1831C10.5731 13.1734 9.71816 12.3662 8.71525 12.3662C8.25489 12.3662 7.94251 12.4815 7.64657 12.6627C7.39995 12.8275 7.15333 13.0746 6.98892 13.3546H6.95604V9.07159H5.69006V20.471Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5267 12.498L13.5326 19.8616C13.5654 19.9604 13.5654 20.0592 13.5654 20.1581C13.5654 20.2734 13.549 20.3558 13.4832 20.5534C13.3517 20.9323 13.0886 21.4759 12.7598 21.8878C12.3981 22.349 12.0035 22.695 11.6418 22.8926L12.1022 23.9799C12.3817 23.8481 12.9736 23.4692 13.5326 22.7608C14.4697 21.5583 15.0123 19.6309 15.5055 17.6212L16.8044 12.498H15.5548L14.6177 17.0941C14.4862 17.6706 14.3546 18.2801 14.2724 18.7249H14.2395C14.1409 18.2307 14.0587 17.7036 13.9107 17.0776L12.8585 12.498H11.5267Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.9387 20.6028C18.4648 20.6028 18.7772 20.224 18.7772 19.6474C18.7772 19.0708 18.4484 18.692 17.9387 18.692C17.4784 18.692 17.1002 19.0873 17.1002 19.6474C17.1002 20.224 17.4619 20.6028 17.9387 20.6028Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.3721 20.471H21.638V9.07159H20.3721V20.471Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.8383 12.498L24.8441 19.8616C24.877 19.9604 24.877 20.0592 24.877 20.1581C24.877 20.2734 24.8605 20.3558 24.7948 20.5534C24.6632 20.9323 24.4002 21.4759 24.0713 21.8878C23.7096 22.349 23.3151 22.695 22.9533 22.8926L23.4137 23.9799C23.6932 23.8481 24.2851 23.4692 24.8441 22.7608C25.7812 21.5583 26.3238 19.6309 26.817 17.6212L28.1159 12.498H26.8664L25.9292 17.0941C25.7977 17.6706 25.6661 18.2801 25.5839 18.7249H25.5511C25.4524 18.2307 25.3702 17.7036 25.2222 17.0776L24.17 12.498H22.8383Z",
  fill: "white"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 32,
  height: 32,
  fill: "white"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/hylylogo.ac08f262.svg";
export { SvgComponent as ReactComponent };